module.exports = __webpack_public_path__ + "static/img/pass_微服务.3dbe064d.png";